import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

/* Dialogs */
import IrrevocablyInoperableOverlayDialog from '../../../dialogs/irrevocablyInoperableOverlayDialog';

class RequestCreditScrapPolicy extends Component {

	constructor(props) {
		super(props);
		this.state = {
			agree: false,
			showIrrevocablyInoperableOverlayDialog: false,
			showErrormessage: false,
		};
		this.handleDialog = this.handleDialog.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		// Redirect to request return page if there is no data in store, it means page is refreshed
		// if(!this.props.order.requestCreditDetails) {
		// 	browserHistory.push("/requestcredit");
		// }
	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	handleAgree(event) {
		this.setState({
			agree: event.target.checked,
			showErrormessage: false,
		});
	}

	handleContinue(evnet) {
		event.preventDefault();
		const self = this;
		if(self.state.agree) {
			browserHistory.push('/requestcreditstep3');
		} else {
			self.setState({
				showErrormessage: true,
			});
		}
	}

	handleGoToStep(step, event) {
		event.preventDefault();
		browserHistory.push(step);
	}

    render() {
        return (
			<div>
				<div className="d-none d-sm-block">
					<div className="push">
						<h1 className="pageTitle">Request Credit</h1>
					</div>
					<div className="push">
						<h2>Scrap Policy</h2>
						<p>ASMs are responsible for collecting and keeping serial tags on all scrapped products for two years from the date the product is scrapped. Digital copies of tags are acceptable. Please print the scrap confirmation screen, attach the product serial tag(s) and keep the form on file.  The files are subject to audit.</p>
						<div className="margin-btm-2em">
							{this.state.showErrormessage && <p className="bold red">Please agree terms and conditions.</p>}
							<input onClick={this.handleAgree.bind(this)}  type="checkbox" className="margin-r-1em" /><span className="bold">I certify that:</span>
							<ul>
								<li className="pad-b-1em">The serial tags have been removed from these products and provided to the ASM;</li>
								<li className="pad-b-1em">These units have been rendered completely and <a href="" onClick={(e) => this.handleDialog('IrrevocablyInoperableOverlayDialog', true, e)} className="bold">irrevocably inoperable</a>;</li>
								<li>Pictures will be uploaded in JPG format before submittal showing the following :</li>
								<ul>
									<li style={{listStyleType: 'lower-alpha'}}>Serial tag removal (model and Serial must be clearly visible)</li>
									<li style={{listStyleType: 'lower-alpha'}}>The Damage or Defect requiring the unit to be scrapped ( unless the defect is functional/internal )</li>
									<li style={{listStyleType: 'lower-alpha'}}>Proof that the unit is inoperable (i.e. cut cord)</li>
								</ul>
								
							</ul>
						</div>
						<div className="columns">
							<div className="column">
								<input onClick={(e) => this.handleGoToStep('/requestcredit', e)} type="button" defaultValue="Cancel" className="blueButton" />
							</div>
							<div className="column textRight">
								<input type="submit" onClick={this.handleContinue.bind(this)} value="Continue" />
							</div>
						</div>
						<p>
							<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
						</p>
					</div> {/* / .push */}
					{this.state.showIrrevocablyInoperableOverlayDialog?<IrrevocablyInoperableOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				</div>

{/* Mobile view */}

				<div className="d-block d-sm-none container">

					<div className="push">
						<h1 className="pageTitle">Request Credit</h1>
					</div>

					<div className=''>
						<div className='row'>
							<h2>Scrap Policy</h2>
							<p>ASMs are responsible for collecting and keeping serial tags on all scrapped products for two years from the date the product is scrapped. Digital copies of tags are acceptable. Please print the scrap confirmation screen, attach the product serial tag(s) and keep the form on file.  The files are subject to audit.</p>
						</div>
					</div>

					<div className=''>
					{this.state.showErrormessage &&<div className='row mb-2'>
						 <p className="bold red">Please agree terms and conditions.</p>
						</div>}
						<div className='row mb-2' >
							<div className="form-check">
								<input 
								className="form-check-input checkbox-size" 
								type="checkbox" 
								onChange={this.handleAgree.bind(this)} 
								name="checkboxConfirm"
								id="checkboxConfirm"
								/>
								<label className="form-check-label bold checkBox-label" htmlFor="checkboxConfirm">
								I certify that:
								</label>
							</div>
						</div>
						<div className='row'>
							<ul className='requestCreditUl'>
									<li className="pad-b-1em">The serial tags have been removed from these products and provided to the ASM;</li>
									<li className="pad-b-1em">These units have been rendered completely and <a href="" onClick={(e) => this.handleDialog('IrrevocablyInoperableOverlayDialog', true, e)} className="bold">irrevocably inoperable</a>;</li>
									<li>Pictures will be uploaded in JPG format before submittal showing the following:</li>
									<ul>
										<li>Serial tag removal (model and Serial must be clearly visible)</li>
										<li>The Damage or Defect requiring the unit to be scrapped ( unless the defect is functional/internal )</li>
										<li>Proof that the unit is inoperable (i.e. cut cord)</li>
									</ul>
									
								</ul>
						</div>
					</div>

					<div className="d-flex justify-content-between mt-3 ps-1 pe-1">
							<span>
								<button id="cancelButton" className='btnSize cancelButtonSpec' onClick={(e) => this.handleGoToStep('/requestcredit', e)}>Cancel</button>
							</span>
							
							<span>
								<button id="continueButton" className='btnSize' onClick={this.handleContinue.bind(this)}>Continue</button>
							</span>
						</div>
					

					<div className="container mt-4 backLink">
					<a href="" onClick={(e) => this.handleGoToStep('/requestcreditstep2', e)} className="bold">Return to previous screen</a>
					</div>
					{this.state.showIrrevocablyInoperableOverlayDialog?<IrrevocablyInoperableOverlayDialog handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
					<div style={{height:"200px"}}></div>


				</div>
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

RequestCreditScrapPolicy = connect(mapStateToProps)(RequestCreditScrapPolicy);
export default RequestCreditScrapPolicy;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/RequestCredit/requestCreditScrapPolicy.js